"use client";
import React, { useState } from "react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { StaticImport } from "next/dist/shared/lib/get-img-props";
import { ChevronLeft, X } from "lucide-react";
import ProductSlider from "./productSlider";
import { Product } from "@/types/slider.type";
import Link from "next/link";
import APP_ROUTES from "@/constants/paths";

interface FilterSliderProps {
  image: StaticImport | null;
  products: Product[];
  filters: string[];
}

const FilterSlider: React.FC<FilterSliderProps> = ({ products, filters }) => {
  const [activeFilters, setActiveFilters] = useState<string[]>([]);

  const toggleFilter = (filter: string) => {
    setActiveFilters((prev) =>
      prev.includes(filter)
        ? prev.filter((f) => f !== filter)
        : [filter, ...prev]
    );
  };

  return (
    <div
      dir="rtl"
      className="w-full h-fit relative my-8 min-sm:px-1 place-self-center min-sm:rounded-[20px] bg-[#3663FF]"
    >
      <div className="flex flex-row w-full items-center justify-between pt-6 px-6">
        <div className=" flex flex-row gap-x-2  items-center">
          <svg
            width={20}
            height={20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3 0C1.34315 0 0 1.34315 0 3V7.31802C0 8.11367 0.31607 8.87673 0.878679 9.43934L10.4598 19.0205C11.3791 19.9398 12.8489 20.2064 14.0073 19.448C16.1742 18.0293 18.0293 16.1742 19.448 14.0073C20.2064 12.8489 19.9398 11.3791 19.0205 10.4598L9.43934 0.878679C8.87673 0.31607 8.11367 0 7.31802 0H3ZM4.125 5.25C4.74632 5.25 5.25 4.74632 5.25 4.125C5.25 3.50368 4.74632 3 4.125 3C3.50368 3 3 3.50368 3 4.125C3 4.74632 3.50368 5.25 4.125 5.25Z"
              fill="white"
            />
          </svg>

          <div className=" text-white font-bold text-2xl max-sm:text-xl">
            تخفیف های شگفت انگیز
          </div>
        </div>

        <div className="flex overflow-auto text-base max-sm:text-xs h-fit items-center gap-2">
          {filters.map((filter) => (
            <button
              key={filter}
              onClick={() => toggleFilter(filter)}
              className={`min-w-fit px-4 py-2 justify-center rounded-full max-sm:mb-1 cursor-pointer hover:brightness-90 md:flex hidden ${
                activeFilters.includes(filter)
                  ? "bg-[#ffffff24] text-white"
                  : "bg-[#F2C500] text-[#483D0A]"
              }`}
            >
              {activeFilters.includes(filter) && <X />}
              <span
                className={` ${
                  activeFilters.includes(filter)
                    ? "font-semibold"
                    : "font-normal"
                }`}
              >
                {filter}
              </span>
            </button>
          ))}

          <Link
            aria-label="مشاهده همه محصولات بیشتر"
            href={APP_ROUTES.FILTER + "?SortOrder=MostDiscount"}
          >
            <div className="text-white text-[16px] flex flex-row gap-x-1 cursor-pointer hover:brightness-90">
              همه <ChevronLeft />
            </div>
          </Link>
        </div>
      </div>

      <ProductSlider
        products={
          activeFilters.length > 0
            ? products
                .filter(
                  (p) =>
                    !!p.categories?.filter((c) =>
                      activeFilters.includes(c?.name ?? "")
                    ).length
                )
                .filter((p) => p.discountedPrice !== p.price)
            : products.filter((p) => p.discountedPrice !== p.price)
        }
      />
    </div>
  );
};

export default FilterSlider;
